<template>
<el-dialog title="绑定手机号码" :visible.sync="visible" :close-on-click-modal="false" width="30%" :before-close="beforeClose">
    <el-form ref="form" :model="iform" :rules="rules" label-width="0px">
        <el-form-item label="" prop="mobile">
            <el-input placeholder="您的手机号码" ref="ifmobile" v-model="iform.mobile"></el-input>
        </el-form-item>
        <el-form-item label="" prop="mcode">
            <el-input placeholder="短信验证码" v-model="iform.mcode" autocomplete="off"></el-input>
            <el-button type="text" :disabled="waitnum > 0" @click="onOpenVerify">
                {{ waitnum > 0 ? waitnum + '秒后重新发送' : '发送验证码' }}
            </el-button>
        </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="onSubmit">提交绑定</el-button>
    </div>

    <Verify ref="verify" :captcha-type="'blockPuzzle'" :img-size="{width:'400px',height:'200px'}" @success="toSendMsg"></Verify>
</el-dialog>
</template>

<script>
import Y from '@/utils/Y'
import Verify from '@/components/Verifition/Verify.vue'
import EReg from '@/utils/EReg.js'
import EFormat from '@/utils/EFormat.js'
// import * as IUser from '@/api/user.js'

export default {
    props: {
    },
    data() {
        // 检查手机号码
        var v_mobile = (rule, value, callback) => {
            if (! EReg.isSimMobile(value)) {
                callback(new Error('非法的手机号码!'))
            } else {
                callback()
            }
        }

        // 返回data
        return {
            visible: false,
            waitnum: 0,
            wtimer: null,
            iform: {
                mobile: '',
                mcode: '',
                mkey: '',
            },

            rules: {
                mobile: [
                    { required: true, message: '请输入您的手机号码', trigger: 'blur' },
                    { validator: v_mobile, trigger: 'blur' },
                    { validator: this.checkMobile.bind(this), trigger: 'blur' }
                ],
                mcode: [
                    { required: true, message: '请输入短信验证码', trigger: 'blur' },
                    { pattern: /^[0-9]{6}$/, message: '验证码格式错误', trigger: 'blur' }
                ]
            }
        }
    },
    components: { Verify },
    methods:{
        
        onSubmit () {
            if ( !EReg.isSimMobile(this.iform.mobile) ) {
                Y.msg.warning('非法的手机号码！')
                return false
            }

            if ( !this.isCode(this.iform.mcode) ) {
                Y.msg.warning('请输入短信验证码！')
                return false
            }

            let param = {}
            param.mobile = EFormat.encrypt(this.iform.mobile)
            param.code   = EFormat.encrypt(this.iform.mcode)
            param.key    = this.iform.mkey

            IUser.fBindMobile( param ).then( rlt => {
                console.log( rlt )
            } )
        },

        /**
        * 检查手机号码是否可用
        */
        checkMobile ( rule, value, callback2 ) {
            if ( !value ) {
                return callback2();
            }

            // 检查手机号码
            let param = { mobile: value }

            IUser.fCheckMobile( param ).then( rlt => {
                if ( rlt.code == 500 ) {
                    Y.msg.warning( '手机号已被占用，请更换号码' )
                    callback2(new Error( '手机号已被占用，请更换号码' ))
                    this.$refs.ifmobile.focus()
                }
            } )

            callback2();
        },

        /**
         * 打开滑块验证码
        */
        onOpenVerify () {
            let imobile = this.iform.mobile || ''

            if (!EReg.isSimMobile(imobile)) {
                Y.msg.warning('非法的手机号码！')
                this.$refs.ifmobile.focus()
            } else {
                this.$refs.verify.show()
            }
        },

        /**
         * 发送短信接口
        */
        toSendMsg (rlt) {
            let param = {}
            param.mobile = EFormat.encrypt(this.iform.mobile)
            param.key    = rlt.captchaVerification

            this.startWait()

            // 发送登录短信
            IUser.fSendBind( param ).then(rlt => {
                if ( rlt.code == 200 ) {
                    this.iform.mkey = param.key
                    Y.msg.success('验证码已发送')
                } else if ( rlt.msg ) {
                    this.stopWait()
                    Y.msg.warning(rlt.msg)
                } else {
                    this.stopWait()
                    Y.msg.warning('短信发送失败！')
                }
            })
        },

        /**
         * 开始倒计时
        */
        startWait () {
            this.waitnum = 60

            if ( this.wtimer ) {
                this.stopWait()
            }

            this.wtimer = setInterval(() => {
                this.waitnum--

                // 倒计时结束
                if ( this.waitnum <= 0 ) {
                    this.stopWait()
                }
            }, 1000)
        },

        /**
         * 停止倒计时
        */
        stopWait () {
            clearInterval(this.wtimer)
            this.wtimer  = null
            this.waitnum = 0
        },

        // 短信验证码是否合法
        isCode(txt) {
            let reg = /^[0-9]{6}$/

            return reg.test(txt)
        },


        /**
         * 开启窗口
        */
        open () {
            this.visible = true
        },

        /**
         * 关闭窗口
        */
        close () {
            this.visible = false
        },

        // 关闭窗口
        beforeClose (done) {
            done()
        }
    }
}
</script>

<style lang="less" scoped>
</style>